module.exports = __webpack_public_path__ + "img/river_painter5.289f09ff.png";